import { overrideLabel } from '../../utils/client'

/**
 * Single source of truth for account navigation.
 * Figma-only items without backend routes/data are omitted.
 */
export const getAccountNavItems = ({
  referralActive = false,
  hasVod = false
} = {}) => {
  const items = [
    {
      id: 'bookings',
      label: 'My bookings',
      to: '/my-account/bookings',
      icon: 'check-circle',
      shortcut: true,
      shortcutLabel: 'Bookings'
    },
    {
      id: 'memberships',
      label: 'My memberships',
      to: '/my-account/memberships',
      icon: 'coins',
      shortcut: true,
      shortcutLabel: 'Memberships'
    },
    {
      id: 'purchases',
      label: 'All purchases',
      to: '/my-account/purchases',
      icon: 'banknote',
      shortcut: true,
      shortcutLabel: 'Purchases'
    },
    {
      id: 'edit-profile',
      label: 'Edit profile',
      to: '/my-account/edit-profile',
      icon: 'user'
    },
    {
      id: 'contacts',
      label: overrideLabel({
        key: 'label_related_contact',
        value: 'My contacts'
      }),
      to: '/my-account/related-contacts',
      icon: 'contacts'
    },
    {
      id: 'emergency-contacts',
      label: 'Emergency contacts',
      to: '/my-account/emergency-contacts',
      icon: 'smile'
    },
    {
      id: 'payment-methods',
      label: 'Billing',
      to: '/my-account/payment-method',
      icon: 'bank'
    }
  ]

  if (referralActive) {
    items.push({
      id: 'refer',
      label: 'Refer and earn',
      to: '/my-account/refer-and-earn',
      icon: 'users'
    })
  }

  if (hasVod) {
    items.push({
      id: 'vod',
      label: 'Video library',
      to: '/my-account/video-library',
      icon: 'grid'
    })
  }

  items.push({
    id: 'change-password',
    label: 'Reset password',
    to: '/my-account/change-password',
    icon: 'help'
  })

  items.push({
    id: 'logout',
    label: 'Log out',
    action: 'logout',
    icon: 'logout',
    showChevron: false
  })

  return items
}

export const getAccountShortcuts = options =>
  getAccountNavItems(options).filter(item => item.shortcut)

export const resolveActiveNavId = pathname => {
  if (!pathname) return null
  if (pathname.startsWith('/my-account/bookings')) return 'bookings'
  if (pathname.startsWith('/my-account/memberships')) return 'memberships'
  if (pathname.startsWith('/my-account/purchases')) return 'purchases'
  if (pathname.startsWith('/my-account/edit-profile')) return 'edit-profile'
  if (pathname.startsWith('/my-account/related-contacts')) return 'contacts'
  if (pathname.startsWith('/my-account/add-related-contacts')) return 'contacts'
  if (pathname.startsWith('/my-account/emergency-contacts'))
    return 'emergency-contacts'
  if (pathname.startsWith('/my-account/add-emergency-contacts'))
    return 'emergency-contacts'
  if (pathname.startsWith('/my-account/payment-method'))
    return 'payment-methods'
  if (pathname.startsWith('/my-account/refer-and-earn')) return 'refer'
  if (pathname.startsWith('/my-account/video-library')) return 'vod'
  if (pathname.startsWith('/my-account/change-password'))
    return 'change-password'
  if (pathname === '/my-account') return 'account'
  return null
}
